var DOMPurify = require('dompurify');

var FORM_EVENTS = ['contactUs', 'programSignup'];

var FORM_NAMES = [
    'Sunday Gospels',
    'Rediscover the Rosary',
    'Daily Reflections',
    'Prayer Request',
    'Book List',
    'Decision Point',
    'Best Lent Ever',
    'Best Advent Ever',
    'Better Together Preparation',
    'Better Together Enrichment',
    'DEP Fulton Sheen Onsite',
    'DEP Fulton Sheen PopUp',
    'BAE All Bonus Onsite',
    'BAE All Bonus PopUp',
    'Bonus BAE Christmas Traditions Onsite',
    'Bonus BAE About Advent Onsite',
    'Bonus BAE Advent Prayers Onsite',
    'Bonus BAE DIY Advent Calendar Onsite',
    'Bonus BAE Twelve Days Christmas Onsite',
    'Bonus BAE Advent Wreath Prayers Onsite',
    'Bonus BAE St Nicholas Onsite',
    'Bonus BAE Advent Candles Onsite',
    'Bonus BAE Family Advent Activities Onsite',
    'Bonus BAE Christmas Traditions PopUp',
    'Bonus BAE About Advent PopUp',
    'Bonus BAE Advent Prayers PopUp',
    'Bonus BAE DIY Advent Calendar PopUp',
    'Bonus BAE Twelve Days Christmas PopUp',
    'Bonus BAE Advent Wreath Prayers PopUp',
    'Bonus BAE St Nicholas PopUp',
    'Bonus BAE Advent Candles PopUp',
    'Bonus BAE Family Advent Activities PopUp',
    'BAE Onsite',
    'BAE PopUp',
    'BCE Onsite',
    'BCE PopUp',
    'BLE All Bonus Onsite',
    'BLE All Bonus PopUp',
    'Bonus BLE Stations Cross Onsite',
    'Bonus BLE About Lent Onsite',
    'Bonus BLE Ash Wednesday Onsite',
    'Bonus BLE Catholic Fasting Onsite',
    'Bonus BLE Fat Tuesday Onsite',
    'Bonus BLE Holy Week Onsite',
    'Bonus BLE Lent Prayers Onsite',
    'Bonus BLE Things To Give Up Onsite',
    'Bonus BLE Stations Cross PopUp',
    'Bonus BLE About Lent PopUp',
    'Bonus BLE Ash Wednesday PopUp',
    'Bonus BLE Catholic Fasting PopUp',
    'Bonus BLE Fat Tuesday PopUp',
    'Bonus BLE Holy Week PopUp',
    'Bonus BLE Lent Prayers PopUp',
    'Bonus BLE Things To Give Up PopUp',
    'BLE Onsite',
    'BLE PopUp',
    'BLE Onsite 2',
    'BLE PopUp 2',
    'Blessed First Reconciliation Onsite',
    'Blessed First Communion Onsite',
    'Daily Reflections Onsite',
    'Daily Reflections PopUp',
    'Decision Point Onsite',
    'Sunday Gospel Onsite',
    'Sunday Gospel PopUp',
    'DEP Fulton Sheen Onsite',
    'Better Together Enrichment Onsite',
    'Better Together Preparation Onsite',
    'DEP Mother Teresa Onsite',
    'DEP Mother Teresa PopUp',
    'Pilgrimages Onsite',
    'DEP Rosary Rediscover Rosary All Onsite',
    'DEP Rosary Rediscover Rosary All PopUp',
    'DEP Rosary Rediscover Rosary Onsite',
    'DEP Rosary How To Pray Onsite',
    'DEP Rosary Mysteries Rosary OnSite',
    'DEP Rosary Joyful Mysteries Onsite',
    'DEP Rosary Luminous Mysteries Onsite',
    'DEP Rosary Sorrowful Mysteries Onsite',
    'DEP Rosary Glorious Mysteries Onsite',
    'DEP Rosary Beliefs About Mary Onsite',
    'DEP Rosary History Rosary Onsite',
    'DEP Rosary Marian Apparitions Onsite',
    'DEP Rosary Fatima Message Onsite',
    'DEP Rosary Rediscover Rosary PopUp',
    'DEP Rosary How To Pray PopUp',
    'DEP Rosary Mysteries Rosary PopUp',
    'DEP Rosary Joyful Mysteries PopUp',
    'DEP Rosary Luminous Mysteries PopUp',
    'DEP Rosary Sorrowful Mysteries PopUp',
    'DEP Rosary Glorious Mysteries PopUp',
    'DEP Rosary Beliefs About Mary PopUp',
    'DEP Rosary History Rosary PopUp',
    'DEP Rosary Marian Apparitions PopUp',
    'DEP Rosary Fatima Message PopUp',
    'Welcome Parish Resources Onsite',
    'Weekly Deals OnSite',
    'Starting Point Onsite',
    'Weekly Deals PopUp',
    'Prayer Requests Onsite',
    'Prayer Requests PopUp',
    'DEP Dreams Grandchild Onsite',
    'DEP Mindful Catholic Onsite',
    'DEP Works of Mercy Onsite',
    'DEP Works of Mercy PopUp',
    'MK Top Ten Books Onsite',
    'Weekly Deals PopUp',
    'Holy Moments Challenge PopUp',
    'Holy Moments Challenge Onsite',
    'Holy Moments Show PopUp',
    'Holy Moments Show Onsite',
    'Daily Reflections PopUp',
    'BLE PopUp 2',
    'BLE Onsite 2',
    'nine words Onsite',
    'nine words PopUp',
    'TOB PopUp',
    'TOB Onsite',
    'theology for beginners Onsite',
    'theology for beginners PopUp',
    '1001 reasons Onsite',
    '1001 reasons PopUp',
    'beautiful hope Onsite',
    'beautiful hope PopUp',
    'franciscan wisdom Onsite',
    'franciscan wisdom PopUp',
    'making sense suffering Onsite',
    'making sense suffering PopUp',
    'the Mass Onsite',
    'the Mass PopUp',
    'the bible Onsite',
    'the bible PopUp',
    'how to make decisions Onsite',
    'how to make decisions PopUp',
    'pillar page Onsite',
    'mvp genius lectio divina Onsite',
    'mvp genius litanies Onsite',
    'adoration Onsite',
    'mvp genius novenas Onsite',
    'common prayers Onsite',
    'digital download PopUp',
    'DEP Rosary PDF Download PopUp',
    'free pilgrimage Onsite',
    'catholic prayer Onsite',
    'catholic prayer PopUp',
    'lectio divina Onsite',
    'lectio divina PopUp',
    'litanies Onsite',
    'litanies PopUp',
    'eucharistic adoration Onsite',
    'eucharistic adoration PopUp',
    'novenas Onsite',
    'novenas PopUp',
    'common catholic prayers Onsite',
    'common catholic prayers PopUp',
    'Beautiful Eucharist PopUp',
    'Beautiful Eucharist Onsite',
    'Beautiful Eucharist ISE',
    'Prayer Request Onsite',
    'Holy Week Retreat Onsite1',
    'Holy Week Retreat Onsite2'
];

var Tracking = {
    pageParameters: null,

    /**
     * @returns Tracking
     */
    init: function () {
        this.pageParameters = this.queryParamsToObject();

        return this;
    },

    /**
     * @returns object
     */
    queryParamsToObject: function () {
        var params = window.location.search;

        if (!params) {
            return {};
        }

        var results = {};

        var items = params.slice(1).split('&');

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var parts = item.split('=');

            results[parts[0]] = parts[1] ? decodeURIComponent(parts[1]) : '';
        }

        return results;
    },

    /**
     * @returns boolean
     */
    pageIsFormConfirmation: function () {
        var param = this.pageParameters.is_form_confirmation;

        return param && (param === '1' || param === 'true');
    },

    /**
     * @returns object
     */
    getFormConfirmationData: function () {
        if (!this.pageIsFormConfirmation()) {
            return;
        }

        return {
            event: this.validateFormEvent(this.pageParameters.form_event),
            formName: this.validateFormName(
                this.pageParameters.form_event_name
            ),
        };
    },

    /**
     * @param {*} event
     * @returns string
     */
    validateFormEvent: function (event) {
        return FORM_EVENTS.includes(event) ? event : '';
    },

    /**
     * @param {*} name
     * @returns string
     */
    validateFormName: function (name) {
        return FORM_NAMES.includes(name) ? name : '';
    },

    setCookiesForPage: function () {
        this.setSalesforceMarketingCloudCookies();
    },

    setSalesforceMarketingCloudCookies: function () {
        if (!this.pageParameters.hasOwnProperty('sfmc_sub')) return;

        var value = '';
        value += 'j=' + DOMPurify.sanitize(this.pageParameters.j);
        value += '&jb=' + DOMPurify.sanitize(this.pageParameters.jb);
        value += '&l=' + DOMPurify.sanitize(this.pageParameters.l);
        value += '&mid=' + DOMPurify.sanitize(this.pageParameters.mid);
        value += '&sfmc_sub=' + DOMPurify.sanitize(this.pageParameters.sfmc_sub);
        value += '&u=' + DOMPurify.sanitize(this.pageParameters.u);

        var expirationDate = new Date();
        expirationDate.setHours(expirationDate.getHours() + 48);
        expirationDate = expirationDate.toUTCString();

        document.cookie = 'sfmc_conversion=' + encodeURIComponent(value) + '; expires=' + expirationDate + '; path=/';
    },
};

var tracker = Tracking.init();

tracker.setCookiesForPage();

if ('dataLayerHandler' in window) {
    dataLayerHandler.onInit(function (handler) {
        var formConfirmationData = tracker.getFormConfirmationData();

        if (tracker.pageIsFormConfirmation()) {
            handler.pushToDataLayerWithClient(formConfirmationData);
        }
    });
}
